import axios from "axios";
import { IDENTITY_GET_TOKEN_PATH_KEY } from "../Constants/RequestKeys";

const identityApi = axios.create({
  baseURL: process.env.REACT_APP_IDENTITY_API_URL_KEY || "",
});

identityApi.interceptors.request.use((config) => {
  config.headers = {
    Authorization: localStorage.getItem("token") ? `${localStorage.getItem("token")}` : "",
  };
  return config;
}, (err) => Promise.reject(err));

export class IdentityService {

  static login(data) {
    // const formData = new URLSearchParams();
    // formData.set('Username', data.username);
    // formData.set('Password', data.password);
    return identityApi.post("/account/login", data);
  };

  static getUserDataByRefreshToken(data) {
    return identityApi.get(`/account/refreshToken?refreshToken=${data}`);
  }
};